import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/newSkill.mapper";
import * as i2 from "../data.requirements";
export class GetWeeklySkillsUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run() {
        return this.data.getNewSkills().pipe(this.mapper.map);
    }
}
GetWeeklySkillsUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetWeeklySkillsUseCase_Factory() { return new GetWeeklySkillsUseCase(i0.ɵɵinject(i1.newSkillMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GetWeeklySkillsUseCase, providedIn: "root" });
